import { summarizeOrderPayments } from "@/utils/orderPaymentSummary";
import { summarizeOrderSpecifiedPaymentTotal } from "@/utils/orderSpecifiedPaymentTotal";
import { summarizeRefundAmounts } from "@/utils/refundAmountSummary";

// src/utils/processResult.ts
export function processResult(d: any) {
  const result: any = {};
  result.mall_id = d.mall_id;
  result.shop_no = d.shop_no;
  result.start_date = d.start_date;
  result.end_date = d.end_date;
  result.datetime = d.datetime;
  result.updated_at =
    typeof d.updated_at === "number" && d.updated_at > 0
      ? d.updated_at
      : undefined;

  const orders = d.orders || [];
  const refunds = d.refunds || [];

  result.orders = orders;
  result.refunds = refunds;

  result.payment_summary = summarizeOrderPayments(orders);
  result.order_count = result.payment_summary.orderCount;
  result.payment_composition_amount =
    summarizeOrderSpecifiedPaymentTotal(orders).totalAmount;

  const refundSummary = summarizeRefundAmounts(refunds);
  result.refund_amount = refundSummary.amount;
  result.refund_breakdown = refundSummary.breakdown;
  result.refund_count = refunds.length;

  result.total_amount =
    result.payment_composition_amount + result.refund_amount;
  result.total_count = result.order_count + result.refund_count;

  return result;
}
